const city = {
    getlist: 'city/getlist',
    add: 'city/add',
    update: 'city/update',
    remove: 'city/remove',
    get: 'city/get',
    getall: 'city/getall',
    clearcache: 'city/clear-cache',
}
export default city
